import { render } from "./CoolpadMobileUI.vue?vue&type=template&id=1fb89a6d"
import script from "./CoolpadMobileUI.vue?vue&type=script&lang=js"
export * from "./CoolpadMobileUI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__